import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { CoachService } from 'src/app/services/coach.service';
import { SchoolService } from 'src/app/services/school.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-school-sidebar-nav',
  templateUrl: './school-sidebar-nav.component.html',
  styleUrls: ['./school-sidebar-nav.component.scss'],
})
export class SchoolSidebarNavComponent implements OnInit {
  show_menu:boolean=true;
  constructor(
    private authService: AuthService,
    private schoolService: SchoolService,
  ) {
    this.schoolService.showleftMenue.subscribe((res) => {
      if (res == true) {
        this.schoolService.showleftMenue.next(false);
      }
    });
  }

  ngOnInit(): void {}
  logout() {
    Swal.fire({
      title: 'LOGOUT',
      text: 'Are you sure you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.schoolLogout();
      }
    });
  }
}
